<template>
  <!-- 减脂食品研究所 -->
  <div class="banner-page">
    <img v-if="imageUrl" class="banner-image" :src="imageUrl" alt="" />
    <div class="not-img" v-else>没什么可看的内容</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imageUrl: ''
    }
  },
  created() {
    this.getImageUrl()
  },
  methods: {
    getImageUrl() {
      this.imageUrl = decodeURIComponent(
        (this.$route.query && this.$route.query.imageUrl) || ''
      )
      let title = decodeURIComponent(
        (this.$route.query && this.$route.query.title) || ''
      )
      if (title) {
        document.title = title
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-page {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background-color: #fff;
  .banner-image {
    width: 100%;
    height: auto;
  }
  .not-img {
    margin: 10vw auto;
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
  }
}
</style>
